import { QueryClient } from '@tanstack/react-query'
import { getStepData } from '.'
import { getFormDocumentQueryKey } from '../document/document-loader'
import { IFormDocumentData } from '../document'

export const getFormStepQueryKey = (recipientId: string, stepId: string) => ['step', recipientId, stepId]

export const formStepQuery = (recipientId: string, stepId: string) => ({
  queryKey: getFormStepQueryKey(recipientId, stepId),
  queryFn: async () => getStepData(recipientId, stepId),
})

export const formStepLoader =
  (queryClient: QueryClient) =>
  async ({ params }: any) => {
    const query = formStepQuery(params.recipientId, params.stepsId)
    const queryResult = queryClient.getQueryData(query.queryKey) || (await queryClient.fetchQuery(query))

    const formDocumentQueryKey = getFormDocumentQueryKey(params.recipientId)

    queryClient.setQueryData(
      formDocumentQueryKey,
      (oldData: IFormDocumentData): IFormDocumentData => ({ ...oldData, nextStep: params.stepsId }),
    )

    return queryResult
  }
